import { render } from "./expense-reports.vue?vue&type=template&id=615179d5"
import script from "./expense-reports.vue?vue&type=script&lang=js"
export * from "./expense-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__